<template>
    <DeliveryRequests
        v-if="loaded"
        :excluded-columns="excludedColumns"
        :deliveries="deliveryRequests"
        :selected-delivery-request="selectedDeliveryRequest"
        :show-delivery-request-summary="showDeliveryRequestSummary"
        :default-status-filter="defaultStatusFilter"
        @statusFilterUpdated="fetchDeliveryRequests"
        @update:showDeliveryRequestSummary="showDeliveryRequestSummary = $event"
        @deliveryRequestRowClicked="deliveryRequestRowClicked"
    />
</template>

<script>
import { mapState, mapActions } from "vuex";
import store from "./_store";
import DeliveryRequests from "./_components/DeliveryRequests";
import api from "src/services/api.js";
import { getters } from "src/global-store.js";

export default {
    name: "DeliveryRequestsModule",
    components: {
        DeliveryRequests,
    },
    data() {
        return {
            deliveryRequests: [],
            loaded: false,
            showDeliveryRequestSummary: false,
        };
    },
    computed: {
        defaultStatusFilter() {
            return this.hasClientRole ? "All" : "Default";
        },
        hasClientRole() {
            return getters.hasClientRole();
        },
        isCustomer() {
            return getters.isCustomer();
        },
        isDesigner() {
            return getters.isDesigner();
        },
        ...mapState("$_deliveryRequest", {
            selectedDeliveryRequest: (state) => state.selectedDeliveryRequest,
        }),
        excludedColumns() {
            const columns = [];
            if (this.isCustomer) columns.push("Customer");
            if (this.isDesigner) columns.push("Designers");
            if (this.hasClientRole) columns.push("Est. Cubes");
            const some = this.deliveryRequests
                .map((r) => r.designer_names)
                .filter((r) => r != "");
            if (some.length == 0) {
                columns.push("Designers");
            }
            return columns;
        },
    },
    beforeCreate() {
        this.$store.registerModule("$_deliveryRequest", store);
    },
    destroyed() {
        this.$store.unregisterModule("$_deliveryRequest");
    },
    async created() {
        await this.fetchDeliveryRequests();
        this.loaded = true;
    },
    methods: {
        ...mapActions("$_deliveryRequest", ["fetchDeliveryRequest"]),
        async deliveryRequestRowClicked(row) {
            await this.fetchDeliveryRequest(row.id);
            this.showDeliveryRequestSummary = true;
        },
        async fetchDeliveryRequests(status = null) {
            if (!status) {
                status = this.defaultStatusFilter;
            }
            try {
                this.deliveryRequests = await api.get(
                    "/delivery-requests?status=" + status,
                );
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>
